import { priceFormatter } from "utils/priceFormatter";

export const getUsdPrice = (value: number) => {
  return `${+value >= 0 ? "+" : "-"} $ ${priceFormatter(Math.abs(value))}`;
};
